import "./index.scss";
import { URLS } from "fire-wind-water";

class Index {
  constructor() {
    $sk.template.module(this);
  }

  skUserEnd() {
    // alert("用户信息");
    if (URLS.getURL("des")) {
      // 设计模式
      setTimeout(() => {
        $sk.loading.hide();
      }, 1000);
    }
  }
  skAfterContentInit() {
    // alert("页面元素");
    // const foot: HTMLElement = document.querySelector(".sk-cms-footer");
    // const main: HTMLElement = document.getElementById("sk-cms-main");
    // if (foot && main) {
    //   // main.style.paddingBottom = foot.offsetHeight + 'px';
    // }
    if (!URLS.getURL("des")) {
      setTimeout(() => {
        $sk.loading.hide();
      }, 1000);
    }
    setTimeout(() => {
      // url带锚点，就跳转锚点
      const anchorId = URLS.getURL("anchorId");
      if (anchorId) {
        const elem = document.getElementById(anchorId);
        elem.style.scrollMarginTop = "150px";
        elem.scrollIntoView({ behavior: "smooth" });
      }
      $sk.loading.hide();
    }, 1000);
  }

  skOnDestroy() {
    // $sk.loading.show();
  }
}

export { Index };

$sk.cms.module("pc-template-index", [Index]);
